import "./human_agent_list.page.style.scss";
import LayoutComponent from "../../../layouts/layoutComponent/layout.component";
import "./human_agent_list.page.style.scss";
import { FC } from "react";
import KeyWordLocalization from "../../../utils/KeyWordLocalization";
import PaginatorComponent from "../../../components/paginator/PaginatorComponent";
import LoadingComponent from "../../../components/LoadingComponent/loading.component";
import ButtonComponent from "../../../components/button/button.component";
import NotResultsComponent from "../../../components/noResults/not_results.component";
import { HumanAgentStatus } from "../../../../domain/entities/human_agent.entity";
import useHumanAgentListViewModel from "./human_agent_list.page.view_model";

const HumanAgentListPage: FC<{}> = () => {
    const {
        formInfo,
        result,
        loadingDownload,
        i18n,
        _handleSearch,
        _handleChangeTextSearch,
        _handleChange,
        _handleOnChangePage,
        _handleOnClickAgent,
        _handleOnClickDeleteAgent,
        _handleOnClickUpdateAgent,
        _handleOnCreateSingleAgent,
        _handleDownloadAgents,
        _handleOnBulkImport,
    } = useHumanAgentListViewModel();

    const {
        register,
        handleSubmit,
        getValues,
        reset
      } = formInfo;
      

    return <div className="human_agent_list_page">
        <LayoutComponent title={i18n(KeyWordLocalization.HumanAgentListTitle)}>
            <div className="container py-5">
                <form onSubmit={handleSubmit(_handleSearch)}>
                <div className="row align-items-end">
  <div className="col-md-6 mb-2">
    <input
      type="text"
      className="form-control"
      placeholder={i18n(KeyWordLocalization.AgentListPageSearchInput)}
      {...register(KeyWordLocalization.HumanAgentListPageQuery)}
      onKeyUp={_handleChangeTextSearch}
    />
  </div>

  <div className="col-md-3 mb-2">
    <select
      className="form-control"
      {...register(KeyWordLocalization.HumanAgentEntityStatus, {
        onChange: _handleChange,
      })}
    >
      <option value="">{i18n(KeyWordLocalization.HumanAgentEntityStatusAll)}</option>
      <option value={HumanAgentStatus.active}>{i18n(KeyWordLocalization.HumanAgentEntityStatusActive)}</option>
      <option value={HumanAgentStatus.inactive}>{i18n(KeyWordLocalization.HumanAgentEntityStatusInactive)}</option>
    </select>
  </div>

  <div className="col-md-3 mb-2 d-flex justify-content-between gap-2">
    <ButtonComponent
      className="btn-compact flex-grow-1 d-flex justify-content-center"
      icon={<span className="material-symbols-outlined">search</span>}
      text={i18n(KeyWordLocalization.HumanAgentListPageSearch)}
      design="primaryOutline"
      type="submit"
    />

    <ButtonComponent
      className="btn-compact flex-grow-1 d-flex justify-content-center"
      design="dangerOutline"
      type="button"
      icon={<span className="material-symbols-outlined">refresh</span>}
      text={i18n(KeyWordLocalization.ResetFilters) || "Limpiar"}
      onClick={() => {
        reset({
          [KeyWordLocalization.HumanAgentListPageQuery]: "",
          [KeyWordLocalization.HumanAgentEntityStatus]: "",
        });
        _handleSearch(getValues());
      }}
    />
  </div>
</div>

                    <div className="w-100 d-flex justify-content-end mt-3">
                        <ButtonComponent
                            design="primaryOutline"
                            onClick={_handleDownloadAgents}
                            isLoading={loadingDownload}
                            icon={<span className="material-symbols-outlined">download</span>}
                            className="btn_bulk_import mx-2"
                            text={i18n(KeyWordLocalization.HumanAgentListPageDownloadAgents)}
                        />
                        <ButtonComponent
                            design="primaryOutline"
                            onClick={_handleOnBulkImport}
                            icon={<span className="material-symbols-outlined">upload_file</span>}
                            className="btn_bulk_import mx-2"
                            text={i18n(KeyWordLocalization.HumanAgentListPageBulkImport)}
                        />
                        <ButtonComponent
                            design="primaryOutline"
                            onClick={_handleOnCreateSingleAgent}
                            icon={<span className="material-symbols-outlined">add</span>}
                            className="btn_bulk_import"
                            text={i18n(KeyWordLocalization.HumanAgentListPageAddAgent)}
                        />
                    </div>

                    <div className="list">
                        {result == undefined && <div className="mt-5">
                            <LoadingComponent />
                        </div>}
                        {result && result.data.length == 0 && <NotResultsComponent />}
                        {result && result.data.length > 0 && <table className="table my-3" style={{ tableLayout: "auto" }}>
                            <thead>
                                <tr>
                                    <th>{i18n(KeyWordLocalization.HumanAgentListPageId)}</th>
                                    <th>{i18n(KeyWordLocalization.HumanAgentListPageName)}</th>
                                    <th>{i18n(KeyWordLocalization.HumanAgentEntityInternalId)}</th>
                                    <th>{i18n(KeyWordLocalization.HumanAgentEntityStatus)}</th>
                                    <th>{i18n(KeyWordLocalization.HumanAgentListPageActions)}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {result.data.map((agent, index) => <tr key={index}>
                                    <td className="hover" onClick={() => _handleOnClickAgent(agent)} style={{ width: 10 }}>
                                        {agent.id}
                                    </td>
                                    <td className="hover" onClick={() => _handleOnClickAgent(agent)}>
                                        {agent.name}
                                    </td>
                                    <td className="hover" onClick={() => _handleOnClickAgent(agent)}>
                                        {agent.agentId}
                                    </td>
                                    <td className="hover" onClick={() => _handleOnClickAgent(agent)}>
                                        {i18n(agent.status == HumanAgentStatus.active ? KeyWordLocalization.HumanAgentEntityStatusActive : KeyWordLocalization.HumanAgentEntityStatusInactive)}
                                    </td>
                                    <td style={{ width: '15em' }}>
                                        <div className="d-flex">
                                            <ButtonComponent
                                                onClick={() => _handleOnClickUpdateAgent(agent)}
                                                className="mx-2"
                                                design="primaryOutline"
                                                icon={<span className="material-symbols-outlined">edit</span>}
                                            />
                                            <ButtonComponent
                                                onClick={() => _handleOnClickDeleteAgent(agent)}
                                                design="dangerOutline"
                                                type="button"
                                                icon={<span className="material-symbols-outlined">delete</span>}
                                            />
                                        </div>
                                    </td>
                                </tr>)}
                            </tbody>
                        </table>}
                    </div>
                    <div className="paginator">
                        {result && result.pages > 1 &&
                            <PaginatorComponent resultData={result} onChangePage={_handleOnChangePage} />
                        }
                    </div>
                </form>
            </div>
        </LayoutComponent>
    </div>
}

export default HumanAgentListPage;